<script>
import moment from "moment";
import { consultarCitasResponsable } from "../../apiService/request/Agendamiento";
import { enviarMensaje } from "../../apiService/request/df_client";
import Icono from "../Icono/Icono";
import { actualizarNotificacionDoctor } from "../../apiService/request/Notificaciones";

export default {
  async created() {
    this.$store.dispatch("doctorNotificaciones");
    await this.consultarCitas();
  },
  mounted() {
    this.$refs.calendar.scrollToTime(
      
    );
    this.$refs.calendar.checkChange();
  },
  data: () => ({
    tipoCalendario: "day",
    hoy: "",
    events: [],
    selectedOpen: false,
    selectedEvent: {},
    selectedElement: null,
    focus: "",
    typeCalendars: [
      {
        text: "Dia",
        value: "day"
      },
      {
        text: "4 Dias",
        value: "4day"
      },
      {
        text: "Semana",
        value: "week"
      }
    ],
    iconoBorrarNotificacion:
      "M31,4h-8V1c0-0.6-0.4-1-1-1H10C9.4,0,9,0.4,9,1v3H1C0.4,4,0,4.4,0,5v4c0,0.6,0.4,1,1,1h1.1L4,43.1C4,43.6,4.5,44,5,44h22c0.5,0,1-0.4,1-0.9L29.9,10H31c0.6,0,1-0.4,1-1V5C32,4.4,31.6,4,31,4z M11,2h10v2H11V2z M26.1,42H5.9L4.1,10h23.9L26.1,42z M30,8H2V6h28V8z M15,35V16c0-0.6,0.4-1,1-1s1,0.4,1,1v19c0,0.6-0.4,1-1,1S15,35.6,15,35z M21,34.9l1-19c0-0.6,0.5-1,1.1-0.9c0.6,0,1,0.5,0.9,1.1l-1,19c0,0.5-0.5,0.9-1,0.9c0,0,0,0-0.1,0C21.4,36,21,35.5,21,34.9z M9,35.1l-1-19c0-0.6,0.4-1,0.9-1.1c0.5,0,1,0.4,1.1,0.9l1,19c0,0.6-0.4,1-0.9,1.1c0,0,0,0-0.1,0C9.5,36,9,35.6,9,35.1z",
    iconoBuscarpaciente:
      "M22,12c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S25.3,12,22,12z M22,2c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S24.2,2,22,2zM26,44c-1.7,0-3-1.3-3-3V29h-2v12c0,1.7-1.3,3-3,3s-3-1.3-3-3V22.4l-3.7,3.7c-1.2,1.2-3.2,1.2-4.4,0c-1.2-1.2-1.2-3.2,0-4.4l8.4-8.4c0.2-0.2,0.4-0.3,0.7-0.3h12c0.3,0,0.5,0.1,0.7,0.3l8.4,8.4c1.2,1.2,1.2,3.2,0,4.4c-1.2,1.2-3.2,1.2-4.4,0L29,22.4V41C29,42.7,27.7,44,26,44z M20,27h4c0.6,0,1,0.4,1,1v13c0,0.6,0.4,1,1,1s1-0.4,1-1V19.9c0-0.4,0.2-0.8,0.6-0.9s0.8-0.1,1.1,0.2l5.4,5.4c0.4,0.4,1.1,0.4,1.6,0c0.4-0.4,0.4-1.1,0-1.6L27.6,15H16.4l-8.1,8.1c-0.4,0.4-0.4,1.1,0,1.6c0.4,0.4,1.1,0.4,1.6,0l5.4-5.4c0.3-0.3,0.7-0.4,1.1-0.2c0.4,0.2,0.6,0.5,0.6,0.9V41c0,0.6,0.4,1,1,1s1-0.4,1-1V28C19,27.4,19.4,27,20,27z M44,0v44 M0,0v44"
  }),
  props: {
    correo: String,
    fecha: String,
    cups: String
  },
  components: {
    Icono
  },
  filters: {
    moment: function(date, format) {
      var fecha = isNaN(date) ? date : Number(date);
      return moment(fecha).format(format);
    }
  },
  computed: {
    getDoctorNotifications: function() {
      return this.$store.getters.getDoctorNotificaciones;
    }
  },
  methods: {
    setToday() {
      this.focus = this.today;
    },
    bloquearAtras() {
      if (!this.focus) {
        return true;
      }
      return moment(this.hoy) >= moment(this.focus);
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    async consultarCitas() {
      const responsable = !this.correo
        ? this.$store.state.provider_email
        : this.correo;
      const dia = !this.fecha
        ? moment()
            .format("YYYY-MM-DD")
            .toString()
        : this.fecha;
      this.hoy = dia;
      this.focus = dia;

      const respuesta = await consultarCitasResponsable(
        responsable,
        "reservado",
        dia
      );
      respuesta.data.data.forEach((cita, index) => {
        if (!this.cups || (this.cups && cita.cups == this.cups)) {
          const event = {
            title: cita.evento,
            name: `${cita.evento} - ${cita.espacioFisico} - ${cita.nombrePaciente}`,
            details: `<strong>Paciente:</strong>  ${
              cita.nombrePaciente
            } <br> <strong>Documento:</strong> ${
              cita.documento
            } <br> <strong>Consultorio:</strong> ${
              cita.espacioFisico
            } <br> <strong>Evento: </strong> ${
              cita.evento
            } <br> <strong>Fecha y hora: </strong> ${moment(
              cita.fechaCita
            ).format("DD-MMM-YYYY")} ${moment(cita.fechaHoraCita).format(
              "HH:mm a"
            )}`,
            start: `${moment(cita.fechaCita).format("YYYY-MM-DD")} ${moment(
              cita.fechaHoraCita
            ).format("HH:mm")}`,
            end: `${moment(cita.fechaCita).format("YYYY-MM-DD")} ${moment(
              cita.fechaHoraCita
            )
              .add(cita.duracion, "minutes")
              .format("HH:mm")}`,
            color: cita.color ? cita.color : "#adb8ff"
          };
          this.events.push(event);
        }
      });
    },
    async enviarMensajesAgenda(documento, evento, idOrden) {
      this.$store.dispatch("setCedulaPaciente", documento);
      await enviarMensaje(documento, this.$store.state.provider_email);
      await enviarMensaje("llenar encuentro", this.$store.state.provider_email);
      await enviarMensaje(idOrden, this.$store.state.provider_email);
      this.$store.dispatch("setMensajeChatBox", evento);
    },
    async enviarMensajeBusquedaPaciente(documento) {
      this.$store.dispatch("setCedulaPaciente", documento);
      await enviarMensaje('Buscar paciente', this.$store.state.provider_email);
      this.$store.dispatch("setMensajeChatBox", this.$store.getters.getCedulaPaciente);
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }
      nativeEvent.stopPropagation();
    },
    async vistaDoctor(notificacion) {
      await actualizarNotificacionDoctor(notificacion.id);
    },
    getEventColor(event) {
      return event.color;
    }
  }
};
</script>
<template src="./AgendaDoctor.html"></template>
<style lang="scss" src="./AgendaDoctor.scss"></style>
<style lang="scss" src="../../styles/Calendar.scss"></style>



// WEBPACK FOOTER //
// src/components/AgendaDoctor/AgendaDoctor.vue